import type { DashJobsToBeDoneOption } from "../events/enums/dash_jobs_to_be_done_option";
import { getDashJobsToBeDoneOptionFromString } from "../events/enums/dash_jobs_to_be_done_option-utils";

export function getCombinedStringFromDashJobsToBeDoneOptions(
  options: (DashJobsToBeDoneOption | undefined)[],
): string {
  return options.filter(Boolean).join(",");
}

export function getDashJobsToBeDoneOptionsFromStrings(
  options: string[],
  filteredValue: string = "",
): DashJobsToBeDoneOption[] {
  return options
    .filter((val) => val !== filteredValue)
    .map(getDashJobsToBeDoneOptionFromString)
    .filter((val): val is DashJobsToBeDoneOption => val !== undefined);
}
